module.exports = __webpack_public_path__ + "static/76invgde-19b1f2585b1c5ea4f7246339b280a0c4.gif";